import { useState, useEffect, useCallback } from 'react';
import { getToken, setToken, clearToken, apiFetch } from '../lib/api';
const API_BASE = import.meta.env.VITE_API_BASE_URL || 'https://coder-api.finhub.workers.dev';
export function useAuth() {
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    // Check existing token on mount
    useEffect(() => {
        const token = getToken();
        if (!token) {
            setIsLoading(false);
            return;
        }
        apiFetch('/api/auth/me')
            .then(setUser)
            .catch(() => {
            clearToken();
        })
            .finally(() => setIsLoading(false));
    }, []);
    // Handle OAuth callback (code in URL after GitHub redirect)
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const state = params.get('state');
        if (!code || !state)
            return;
        // Clean URL immediately
        window.history.replaceState({}, '', window.location.pathname);
        const redirectUri = `${window.location.origin}${window.location.pathname}`;
        fetch(`${API_BASE}/api/auth/github/callback?code=${code}&state=${state}&redirect_uri=${encodeURIComponent(redirectUri)}`)
            .then(r => r.json())
            .then((data) => {
            if (data.accessToken) {
                setToken(data.accessToken);
                setUser(data.user ?? null);
            }
        })
            .catch(console.error)
            .finally(() => setIsLoading(false));
    }, []);
    const login = useCallback(() => {
        const redirectUri = `${window.location.origin}${window.location.pathname}`;
        apiFetch('/api/auth/github', {
            method: 'POST',
            body: JSON.stringify({ redirectUri }),
        }).then(({ authUrl }) => {
            window.location.href = authUrl;
        });
    }, []);
    const logout = useCallback(() => {
        clearToken();
        setUser(null);
    }, []);
    return { user, isAuthenticated: !!user, isLoading, login, logout };
}
